/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { useRequestCommunitiesStripeConnectStatus } from "@packages/sdk";
import type { ThemeType } from "@packages/ui";
import { colors, NoticeIcon, radius, spacing } from "@packages/ui";

const noticeStyle: Interpolation<ThemeType> = (theme) => ({
  borderRadius: radius.full,
  alignItems: "center",
  color: colors.white,
  backgroundColor: theme.semanticColors.accentMedium,
  display: "flex",
  justifyContent: "center",
});

const stylesSize: Record<
  NonNullable<GivingStripeConnectSidebarProps["size"]>,
  Interpolation
> = {
  m: {
    height: spacing.l,
    width: spacing.l,
  },
  l: {
    height: 40,
    width: 40,
  },
};

export type GivingStripeConnectSidebarProps = {
  communityId: number;
  loading?: boolean;
  size?: "m" | "l";
};

export const GivingStripeConnectSidebar = ({
  communityId,
  loading,
  size = "m",
}: GivingStripeConnectSidebarProps) => {
  const { query: stripeConnectStatusQuery } =
    useRequestCommunitiesStripeConnectStatus({
      id: communityId,
    });

  if (loading || stripeConnectStatusQuery.data?.status !== "restricted") {
    return null;
  }

  return (
    <NoticeIcon.Bare
      aria-label="Stripe account restricted"
      css={[noticeStyle, stylesSize[size]]}
    />
  );
};

GivingStripeConnectSidebar.displayName = "GivingStripeConnectSidebar";
